import {
    Component,
    OnInit
} from '@angular/core';
import { CreateUserProto } from '../authentication.constants';
import { WebService } from '../../../http/web-service.service';
import { Url } from '../../../http/url-constants';
import { ToasterService } from '../../../shared/services/toaster.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AppUtilService } from '../../../app-util.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

    public registerRequest = new CreateUserProto();
    public currentYear = new Date().getFullYear();
    public startYear = new Date().getFullYear() - 200;
    public dateOfBirth: Date;

    constructor(public webService: WebService, private toasterService: ToasterService, private router: Router,
                private datePipe: DatePipe, public appUtilService: AppUtilService) {
    }

    ngOnInit(): void {
      this.appUtilService.setBrowserTitle('Register');
    }

    register() {
        this.registerRequest.dateOfBirth = this.datePipe.transform(this.dateOfBirth, 'yyyy-MM-dd\'T\'HH:mm:ss.SSSZ').toString();
        this.webService.post(Url.API.authentication.register, this.registerRequest).subscribe((response) => {
            if (response) {
                this.toasterService.show('Successfully Registered!');
                this.router.navigateByUrl('/login');
            }
        });
    }

}
